import{useState} from "react";
import axios from "axios";
import "./FileUpload.css"
const FileUpload = ({contract,account, provider}) => {
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState("No image selected"); 

   const handleSubmit = async(e)=>{
     e.preventDefault();
     if (file) {
        try {
            const formData = new FormData();
            formData.append("file", file);
    
            const resFile = await axios({
              method: "post",
              url: "https://api.pinata.cloud/pinning/pinFileToIPFS",
              data: formData,
              headers: {
                pinata_api_key: `
                dcf51e7111889cccc1e1`,
              
                pinata_secret_api_key: 
                `0c4fe4a0ee72f015f388ad1fff78f263b08b62ebffa1841234e9bed887688aa8`,
               
                "Content-Type": "multipart/form-data",
              },
            });
        const ImgHash = `https://gateway.pinata.cloud/ipfs/${resFile.data.IpfsHash}`;
       // const ImgHash = `ipfs://${resFile.data.IpfsHash}`;
        contract.add(account,ImgHash);
        alert("Successfully Image Uploaded");
        setFileName("No image selected");
        setFile(null);

        }catch (e) {
        alert("Unable to upload image to Pinata");
      }
    }
   };

   const retrieveFile=(e)=>{
    const data = e.target.files[0]; //files array of files object
    //  console.log(data);
    const reader = new window.FileReader();
    reader.readAsArrayBuffer(data);
    reader.onloadend = () => {
      setFile(e.target.files[0]);
    };
    setFileName(e.target.files[0].name);
    e.preventDefault();
   };


   return(
    <div className = "top">
        <form className ="form" onSubmit = {handleSubmit} >
        <label htmlFor="file-upload" className="choose">
          Choose File
        </label>
        <input
          disabled={!account}
          type="file"
          id="file-upload"
          name="data"
          onChange={retrieveFile}
        /> 
        
       <span className="textArea">Image:{fileName} </span>

       <button type="submit" className="upload" disabled={!file}>
          Upload File
        </button>
        </form>
    </div>
   ); 
};
export default FileUpload;